import React from 'react';
import './dot.scss';

const Dot = (props) => {
  return (<button className={`dot ${props.isActive ? 'active' : ''}`}></button>)
}

export default Dot;
